import Box from '@mui/material/Box';
import CustomButton from '../CustomButton/CustomButton';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from 'context/AuthContext';
import CustomDialog from 'components/dialogs/CustomDialog';
import { useState } from 'react';



export default function SidebarLogout() {
  const [open, setOpen] = useState<boolean>(false);
  const { logout } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);

  const handleLogout = () => {
    setLoading(true);
    setTimeout(() => {
      setOpen(false);
      setLoading(false);
      logout();
    }, 1000);
  };



  return (
    <>
      <Box sx={{ p: 2 }}>
        <CustomButton
          text='Logout'
          variant='outlined'
          intent='primary'
          fullWidth
          onClick={() => setOpen(true)}
          startIcon={<LogoutIcon />}
        />
      </Box>
      <CustomDialog
        open={open}
        title='Logout'
        message='Are you sure you want to logout?'
        buttons={[
          <CustomButton
            text='Cancel'
            variant='outlined'
            onClick={() => setOpen(false)}
            disabled={loading}
          />,
          <CustomButton
            text='Logout'
            color='error'
            onClick={handleLogout}
            loading={loading}
          />
        ]}
      />
    </>
  );
}
